import { Flex } from "antd";
import useWepapp from "../hook/useWepapp";

const { Outlet } = require("react-router-dom")

const OtpComponent = ({
    otpHeader = () => { },
    otpInput = () => { },
    otpFooter = () => { }
}) => {
    const { goToMenu = () => { } } = useWepapp()
    return (
        <Flex vertical style={{ backgroundColor: "#FCF9F6", height: "100vh" }}>
            {/* <Button onClick={() => goToMenu("complete")}>go to Recheck then complete</Button> */}
            <Flex vertical style={{ padding: "5vh", flexGrow: 1, rowGap: "3vh", alignItems: "center" }}>
                {otpHeader()}
                {otpInput()}
            </Flex>
            {otpFooter()}
        </Flex >
    )
}
export default OtpComponent;